import { render, staticRenderFns } from "./PageType.vue?vue&type=template&id=700b6584&scoped=true&"
import script from "./PageType.vue?vue&type=script&lang=js&"
export * from "./PageType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700b6584",
  null
  
)

export default component.exports